exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sweep-code-popover[data-v-d118b948]{padding:8px 8px 0}.sweep-code-popover .qr-code[data-v-d118b948]{width:149px;height:149px;-o-object-fit:contain;object-fit:contain}.sweep-code-popover .tips[data-v-d118b948]{line-height:1;margin-top:10px;margin-bottom:2px;font-size:14px;color:#333;text-align:center}.sweep-code-popover .content-wrap .item[data-v-d118b948]{margin-bottom:16px}.sweep-code-popover .content-wrap h5[data-v-d118b948]{color:#333;font-size:16px}.sweep-code-popover .content-wrap p[data-v-d118b948]{color:#666;font-size:14px;margin-top:12px;white-space:pre}", ""]);

// exports
